import React, { useCallback, useEffect, useState } from 'react';
import { deleteRopa, getRopa, restaurarRopa } from '../../services/apis';
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, IconButton, Paper, Stack, Switch, Tooltip, Typography } from '@mui/material';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import RestoreIcon from '@mui/icons-material/Restore';
import { FormCrearRopa } from './FormCrearRopa';

export const Ropa = () => {
    const [ropa, setRopa] = useState([]);
    const [open, setOpen] = useState(false);
    const [ropaEliminar, setRopaEliminar] = useState(null);
    const [eliminando, setEliminando] = useState(false);
    const [mostrarEliminades, setMostrarEliminades] = useState(false);

    const cargarRopa = useCallback(async () => {
        try {
            const response = await getRopa(mostrarEliminades);

            if (response.success) {
                setRopa(response.data);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    }, [mostrarEliminades]);

    useEffect(() => {
        cargarRopa();
    }, [cargarRopa]);

    const confirmarEliminar = async () => {
        if (!ropaEliminar?.id) {
            return;
        }

        setEliminando(true);
        try {
            const response = await deleteRopa(ropaEliminar.id, mostrarEliminades);
            if (response?.success) {
                setRopa(response.data || []);
                setRopaEliminar(null);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setEliminando(false);
        }
    };

    const restaurar = async (rp) => {
        try {
            const response = await restaurarRopa(rp.id, mostrarEliminades);
            if (response?.success) {
                setRopa(response.data || []);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
        <Box className="clothes-shell">
            <Paper elevation={0} className="clothes-header">
                <Box className="clothes-header-copy">
                    <Typography className="clothes-eyebrow">
                        Samarretes
                    </Typography>
                    <Typography variant="h4" className="clothes-title">
                        Roba registrada
                    </Typography>
                </Box>

                <Stack direction="row" className="clothes-toolbar">
                    <FormControlLabel
                        control={(
                            <Switch
                                checked={mostrarEliminades}
                                onChange={(event) => setMostrarEliminades(event.target.checked)}
                            />
                        )}
                        label="Mostrar eliminades"
                    />
                    <Chip icon={<CheckroomIcon />} label={`${ropa.length} peces`} className="clothes-stat-chip" />
                    <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
                        Afegir
                    </Button>
                </Stack>
            </Paper>

            <Grid container spacing={2} className="clothes-grid">
                {ropa.map((rp) => (
                    <Grid key={rp.id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                        <Paper elevation={0} className={`clothes-card ${Number(rp.eliminado) === 1 ? 'clothes-card-deleted' : ''}`}>
                            <Box className="clothes-color-panel" style={{ backgroundColor: rp.color }}>
                                <CheckroomIcon className="clothes-color-icon" />
                            </Box>
                            <Box className="clothes-card-body">
                                <Box className="clothes-card-heading">
                                    <Typography variant="h6" className="clothes-card-title" title={rp.nombre}>
                                        {rp.nombre}
                                    </Typography>
                                    {Number(rp.eliminado) === 1 ? (
                                        <Tooltip title="Restaurar">
                                            <IconButton
                                                size="small"
                                                color="primary"
                                                className="clothes-restore-button"
                                                onClick={() => restaurar(rp)}
                                            >
                                                <RestoreIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip title="Eliminar">
                                            <IconButton
                                                size="small"
                                                color="error"
                                                className="clothes-delete-button"
                                                onClick={() => setRopaEliminar(rp)}
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </Box>
                                {Number(rp.eliminado) === 1 && (
                                    <Chip size="small" label="Eliminada" color="error" className="clothes-deleted-chip" />
                                )}
                                <Box className="clothes-color-row">
                                    <span className="clothes-color-dot" style={{ backgroundColor: rp.color }} />
                                    <Typography className="clothes-color-code">
                                        {rp.color}
                                    </Typography>
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>
                ))}
            </Grid>

            <FormCrearRopa open={open} setOpen={setOpen} setRopa={setRopa} />

            <Dialog open={Boolean(ropaEliminar)} onClose={() => setRopaEliminar(null)} maxWidth="xs" fullWidth>
                <DialogTitle>Eliminar roba</DialogTitle>
                <DialogContent>
                    <Typography>
                        S'ocultarà <strong>{ropaEliminar?.nombre}</strong> de la llista de roba.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setRopaEliminar(null)} disabled={eliminando}>
                        Cancel·lar
                    </Button>
                    <Button color="error" variant="contained" onClick={confirmarEliminar} disabled={eliminando}>
                        {eliminando ? 'Eliminant...' : 'Eliminar'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};
